import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import './EmailConfirmationPage.css';

function ConfirmEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [confirmationStatus, setConfirmationStatus] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [showResendButton, setShowResendButton] = useState(false);
  const hasAttemptedConfirmation = useRef(false);
  
  useEffect(() => {
    const confirmEmail = async () => {
      if (hasAttemptedConfirmation.current) {
        return;
      }

      if (!token) {
        setConfirmationStatus('Invalid confirmation link. Please try again.');
        setIsLoading(false);
        return;
      }

      try {
        hasAttemptedConfirmation.current = true;
        const response = await axiosInstance.get(`/users/confirm-email-change/${token}`);
        
        if (response.data.success || response.data.message?.includes('success')) {
          setConfirmationStatus(response.data.message || 'Email successfully updated!');
          setIsConfirmed(true);
        } else if (response.data.message) {
          setConfirmationStatus(response.data.message);
          setIsConfirmed(true);
        } else {
          setConfirmationStatus('Email change confirmed successfully!');
          setIsConfirmed(true);
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message?.toLowerCase() || '';
        
        if (errorMessage.includes('expired')) {
          setConfirmationStatus('This confirmation link has expired. Please request a new email change confirmation.');
          setShowResendButton(true);
        } else if (errorMessage.includes('already confirmed') || errorMessage.includes('already exists')) {
          setConfirmationStatus('This email change has already been confirmed.');
          setIsConfirmed(true);
        } else if (errorMessage.includes('invalid token')) {
          setConfirmationStatus('Invalid confirmation link. Please request a new email change confirmation.');
          setShowResendButton(true);
        } else {
          setConfirmationStatus('Error confirming email change. Please try again or contact support.');
          setShowResendButton(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    confirmEmail();
  }, [token]);

  const handleGoToProfile = () => {
    navigate('/profile');
  };

  const handleResendConfirmation = () => {
    navigate('/profile');
  };

  return (
    <div className="account-confirmation-container">
      <div className="confirmation-card">
        <h2>Email Change Confirmation</h2>
        {isLoading ? (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Confirming your email change...</p>
          </div>
        ) : (
          <>
            <p className={`status-message ${confirmationStatus.includes('successfully') || confirmationStatus.includes('already confirmed') ? 'success' : 'error'}`}>
              {confirmationStatus}
            </p>
            {isConfirmed && (
              <button 
                className="go-to-profile-button"
                onClick={handleGoToProfile}
              >
                Go to Your Profile
              </button>
            )}
            {showResendButton && (
              <button 
                className="retry-button"
                onClick={handleResendConfirmation}
              >
                Go to Profile to Request New Confirmation
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ConfirmEmail;
